import { Injectable } from '@angular/core';
import {
  TShirtSizes,
  TShirtSizesForm,
  TShirtSizesKeys,
  TShirtCategory,
} from '@ag-common-lib/lib/models/utils/t-shirt-sizes.model';
import { BaseFormService } from 'ag-common-svc/lib/utils/base-form-service';
import { getShirtCategoryFromSize } from 'ag-common-svc/lib/utils/t-shirt-size.utils';
import onChange from 'on-change';
import { set } from 'lodash';

@Injectable()
export class TShirtSizesFormService extends BaseFormService<Partial<TShirtSizesForm>> {
  constructor() {
    super();
  }

  getFormData(payload: Partial<TShirtSizes>, tShirtCategoryVisible : boolean = true, pathPrefix: string = ''): Partial<TShirtSizesForm> {

    const data = onChange.target(payload);
    const initialData = Object.assign({}, new TShirtSizes(), data);

    if (!tShirtCategoryVisible) {
      initialData[TShirtSizesKeys.tShirtCategory] = TShirtCategory.adult;
    }

    const tShirtSize = initialData?.[TShirtSizesKeys.unisextShirtSize];
    if (tShirtSize) {
      const tShirtSizeCategory = getShirtCategoryFromSize(tShirtSize);
      initialData[TShirtSizesKeys.tShirtCategory] = tShirtSizeCategory;
    }
    const shirtSize = initialData?.[TShirtSizesKeys.genderTShirtSize];
    if (shirtSize) {
      const shirtSizeCategory = getShirtCategoryFromSize(shirtSize);
      initialData[TShirtSizesKeys.shirtCategory] = shirtSizeCategory;
    }

    const formData = onChange(initialData, (path, value, prevValue) => {
      const changePath = pathPrefix ? `${pathPrefix}.${String(path)}` : String(path);
      this.formChangesDetector.handleChange(changePath, value, prevValue);

      switch (path) {
        case TShirtSizesKeys.tShirtCategory: {
          set(payload, path, value);

          if (value !== prevValue && initialData?.[TShirtSizesKeys.unisextShirtSize] != null) {
            set(initialData, TShirtSizesKeys.unisextShirtSize, null);
            set(payload, TShirtSizesKeys.unisextShirtSize, null);
          }
          break;
        }

        case TShirtSizesKeys.shirtCategory: {
          set(payload, path, value);

          if (value !== prevValue && initialData?.[TShirtSizesKeys.genderTShirtSize] != null) {
            set(initialData, TShirtSizesKeys.genderTShirtSize, null);
            set(payload, TShirtSizesKeys.genderTShirtSize, null);
          }
          break;
        }

        case TShirtSizesKeys.genderTShirtSize:
        case TShirtSizesKeys.unisextShirtSize:
          set(payload, path, value);
          break;
      }

      this.formDataSig.update(data => data);
    });

    this.formDataSig.set(formData);
    return formData;
  }
}
